import { TEST_URL } from '@/api/config/api.config';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Any = any;

export const getAdminToken = () => localStorage.getItem('admin_token') || '';

export class AdminUnauthorized extends Error {}

// Запрос к админ-API с заголовком X-Admin-Token. Бросает AdminUnauthorized при 401.
export const adminFetch = async (
  path: string,
  options: { method?: string; body?: Any; token?: string } = {}
) => {
  const token = options.token ?? getAdminToken();
  const res = await fetch(`${TEST_URL}${path}`, {
    method: options.method || 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Admin-Token': token,
    },
    body: options.body ? JSON.stringify(options.body) : undefined,
  });
  if (res.status === 401) throw new AdminUnauthorized();
  const data = res.status === 204 ? null : await res.json().catch(() => null);
  if (!res.ok) {
    const msg =
      data?.errors?.[0] || data?.errors || data?.error || 'Ошибка запроса';
    throw new Error(Array.isArray(msg) ? msg.join('; ') : String(msg));
  }
  return data;
};

// Загрузка файла (multipart) на админ-API. Content-Type НЕ ставим — браузер
// сам выставит boundary. Доп. поля (например slot) едут вместе с файлом.
export const adminUpload = async (
  path: string,
  file: File,
  fields: Record<string, string> = {},
  method = 'PATCH'
) => {
  // Проверка размера до отправки — иначе при превышении nginx вернёт 413 (HTML),
  // и сообщение об ошибке было бы непонятным.
  const MAX_MB = 5;
  if (file.size > MAX_MB * 1024 * 1024) {
    throw new Error(`Файл слишком большой (до ${MAX_MB} МБ)`);
  }
  // Принимаем по MIME ИЛИ по расширению: браузер иногда даёт пустой/octet-stream type.
  const okType = ['image/jpeg', 'image/png'].includes(file.type);
  const okName = /\.(png|jpe?g)$/i.test(file.name);
  if (!okType && !okName) {
    throw new Error('Изображение должно быть JPEG или PNG');
  }
  const fd = new FormData();
  fd.append('image', file);
  Object.entries(fields).forEach(([k, v]) => fd.append(k, v));
  const res = await fetch(`${TEST_URL}${path}`, {
    method,
    headers: { 'X-Admin-Token': getAdminToken() },
    body: fd,
  });
  if (res.status === 401) throw new AdminUnauthorized();
  if (res.status === 413) throw new Error(`Файл слишком большой (до ${MAX_MB} МБ)`);
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    const msg =
      data?.errors?.[0] || data?.errors || data?.error || 'Не удалось загрузить файл';
    throw new Error(Array.isArray(msg) ? msg.join('; ') : String(msg));
  }
  return data;
};
